const t={path:"/api/v1/guest/authenticate",method:"POST"};export{t as GuestAuthenticate};
